import React from 'react';
import ThemedComponent from '../../theme/ThemedComponent';
import Loader from './Loader';

export function LoaderWrapper(): React.JSX.Element {
  return (
    <ThemedComponent>
      <Loader spinnerColor={'white'} spinnerSize={'60px'} stackHeight={'100%'}></Loader>
    </ThemedComponent>
  );
}

export default LoaderWrapper;
